import { useEffect, useRef } from 'react';

export function useClickOutside(callback: (event: Event) => void) {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const handleClick = (event: Event) => {
      if (ref.current && !ref.current.contains(event?.target as Node)) {
        callback(event);
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [callback, ref]);

  return ref;
}
